var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentOrganizations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 88,
    viewBox: "0 0 90 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#811a1icpxa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.042 41.603s.853 2.146-3.624 3.476-6.934 6.591-6.837 11.017v2.853s13.921 5.116 25.726.394c0 0 1.137-11.952-6.934-14.756 0 0-1.673-.493-1.182-2.463 0 0 3.838-2.166 3.148-7.872-.69-5.706-2.881-7.478-5.147-7.607-9.15-.52-9.183 11.481-5.15 14.958z",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.411 59.245s.17-8.336-1.214-11.166c-1.17-2.393-4.185-3.007-6.731-3.79a1.02 1.02 0 0 0-.444-.06c-.186.047-.358.14-.5.269a7.06 7.06 0 0 1-9.363-.779c-3.054.93-5.443.911-7.046 3.674-1.602 2.762-2.396 8.156-2.095 11.335-.008.002 13.752 5.577 27.393.517z",
    fill: "#F79A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.23 27.528c.533-1.77 1.856-3.41 3.657-3.82.538-.124 1.093-.134 1.635-.238.33-.064.652-.16.978-.242a7.712 7.712 0 0 1 4.071.038 5.624 5.624 0 0 1 3.212 2.434c.666 1.137.854 2.493.757 3.804-.096 1.311-.856 3.634-1.214 4.898-.637-.834-.212-3.198-1.103-3.755-.632-.396-1.447-.216-2.184-.091-1.71.293-3.46.229-5.144-.19-.797-.2-1.616-.48-2.421-.318-.7.14-.947.677-1.326 1.271-.27.412-.43 2.463-.66 2.863-.534-.19-.638-3.44-.632-3.908a9.902 9.902 0 0 1 .375-2.746z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.823 33.856a.864.864 0 0 1 .639-.237.61.61 0 0 1 .416.324c.08.165.125.344.13.527.043.73-.196 1.45-.668 2.01-.26.303-.646.569-1.034.476a.38.38 0 0 1-.205-.108.49.49 0 0 1-.09-.18 3.679 3.679 0 0 1-.031-1.753c.043-.252.068-.498.28-.661.176-.136.381-.261.563-.398z",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.081 42.528c.3-.05.625-.116.82-.347a1.31 1.31 0 0 0 .233-.697c.366-2.75 1.383-10.849-1.326-15.49-.379-.663-1.356-.817-1.883-1.326-1.235-1.213-2.817-2.683-5.003-2.668-5.24.036-7.626 2.63-9.773 7.412-1.303 2.9-1.705 11.685-.625 12.536 1.137.896 4.13.824 5.54.964a46.27 46.27 0 0 0 12.017-.384z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.853 29.033c.1-.137.23-.25.379-.328.441-.216.976.038 1.326.379a3.56 3.56 0 0 1 .89 1.67c.135.623.199 1.259.19 1.895.011.782-.013 1.564-.072 2.346a11.027 11.027 0 0 1-.712 3.359c-.442 1.063-1.164 2.035-2.153 2.62-.735-2.63-.803-5.392-.865-8.12-.012-.434-.021-.866-.012-1.298 0-.17-.047-.5.034-.652.082-.151.228-.12.36-.221.21-.157.175-.45.222-.688.073-.345.213-.672.413-.962z",
    fill: "url(#6in5nwq4hb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.975 34.637a1.227 1.227 0 0 0-.536.21 1.179 1.179 0 0 0-.309.443 4.561 4.561 0 0 0 .19 4.15s.892-.957.97-1.056c.307-.399.58-.824.814-1.27.215-.406 1.338-2.295.771-2.528-.358-.146-1.468-.04-1.9.05z",
    fill: "url(#9iuf7nq83c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.259 41.603c-.415-.96-.332-2.058-.19-3.094.127-.902.31-1.83.84-2.57a4.055 4.055 0 0 1 1.941-1.397 8.715 8.715 0 0 1 2.378-.436c1.162-.08 2.329-.06 3.488.057a7.293 7.293 0 0 1 2.368.568 4.867 4.867 0 0 1 2.304 2.384 6.024 6.024 0 0 1 .449 3.31c-.037.483-.21.946-.5 1.335-.34.348-.767.595-1.237.716-1.706.546-3.513.504-5.279.434-1.464-.057-2.944.027-4.386-.257-.845-.165-1.79-.152-2.176-1.05z",
    fill: "url(#o0l7y7xvpd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.368 59.342c-11.813 4.723-25.726-.395-25.726-.395v-2.841c-.106-4.437 2.357-9.7 6.837-11.026 4.481-1.327 4.168-2.878 4.168-2.878-4.031-3.475-4.546-16.075 4.61-15.553 2.273.13 4.461 1.895 5.147 7.609.686 5.714-3.789 8.209-3.789 8.209a1.5 1.5 0 0 0 .569 1.516c.37.286.796.492 1.25.608 8.061 2.798 6.934 14.75 6.934 14.75z",
    fill: "#FFCDAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.28 34.982c1.784 0 3.588-.256 5.223-.968 1.635-.713 3.092-1.916 3.926-3.49a3.673 3.673 0 0 0 .475-1.614c.021-1.073-.66-2.075-1.563-2.653-.904-.578-1.997-.786-3.067-.832-2.306-.096-4.687.554-6.442 2.052a7.01 7.01 0 0 0-2.463 4.97c-.085 2.08 2.21 2.533 3.91 2.535z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.465 59.245s-.9-6.803-2.285-9.64c-1.17-2.392-3.117-4.533-5.663-5.314a1.019 1.019 0 0 0-.443-.06c-.186.047-.357.14-.499.269a7.058 7.058 0 0 1-9.363-.779 12.646 12.646 0 0 0-7.223 5.78c-1.603 2.76-2.211 6.05-1.918 9.229 0 0 13.75 5.575 27.394.515z",
    fill: "#F79A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.658 64.032v-8.631s2.067-7.768 9.25-8.658c7.182-.89 14.953.295 14.953.295s7.578.984 8.952 10.33v7.379s-19.086 5.517-33.155-.715z",
    fill: "#FCC665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.171 36.72c-.307-.189-.684-.32-1.021-.189a.976.976 0 0 0-.366.252c-.532.569-.502 1.453-.333 2.211.094.425.22.843.379 1.249.066.188.161.364.282.523.379.449 1.042.51 1.625.441.345-.04.73-.144.887-.455a1.03 1.03 0 0 0 .091-.379c.157-1.532-.203-2.841-1.544-3.652zM52.62 37.342c.43-.3.988-.53 1.472-.322a1.215 1.215 0 0 1 .665 1.008c.021.423-.052.845-.216 1.235a4.155 4.155 0 0 1-.768 1.37c-.346.405-.834.66-1.364.712a1.388 1.388 0 0 1-1.317-.7 2.274 2.274 0 0 1-.174-.973 1.88 1.88 0 0 1 .085-.757c.209-.521 1.175-1.266 1.616-1.573zM40.81 47.578c-.169.29-.267.614-.288.948.012.196.06.388.14.568.693 1.705 2.13 2.565 3.514 2.963.416.13.847.2 1.283.21 1.307 0 2.599-.898 3.385-2.347a.596.596 0 0 0 .085-.244.691.691 0 0 0-.092-.32c-.49-1.054-.4-2.412-.271-3.65a.617.617 0 0 0-.02-.306.316.316 0 0 0-.189-.158c-.846-.356-1.756-.134-2.652-.168-1.231-.046-2.425-.612-3.658-.614-.55 0-.591.205-.67.892a7.159 7.159 0 0 1-.568 2.226z",
    fill: "#FFCDAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.822 44.034s.71 2.785 2.433 4.61c1.722 1.824 5.8 1.475 5.318-.154-.406-1.366.354-4.456.354-4.456h-8.105z",
    fill: "url(#n6u4rk6xke)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.218 33.752c-.19-.19-.411-.379-.678-.396a.7.7 0 0 0-.544.261c-.13.166-.217.361-.252.569-.09.503-.05 1.02.115 1.504.19.591.53 1.19 1.105 1.415a.641.641 0 0 0 .627-.04.758.758 0 0 0 .218-.462c.226-1.116.262-2.021-.591-2.851z",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.17 38.782c-.544 4.568-3.083 8.336-6.887 8.336-3.804 0-6.886-3.73-6.886-8.336s2.445-9.799 6.252-9.799c3.806 0 8.633.463 7.52 9.799z",
    fill: "#FFCDAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.359 37.276a57.422 57.422 0 0 1-.498-5.453c-.034-.805-.021-1.705.519-2.298.142-.13.27-.275.379-.434.09-.203.139-.422.145-.644.205-1.726 1.454-3.168 2.886-4.15a11.078 11.078 0 0 1 5.284-1.895 6.086 6.086 0 0 1 1.826.077c.605.148 1.185.38 1.724.692.856.464 1.68 1.025 2.289 1.785.608.76.981 1.746.852 2.71a3.22 3.22 0 0 1 1.787 1.937 6.7 6.7 0 0 1 .261 2.764c-.19 2.213-1.03 4.484-2.796 5.83a9.676 9.676 0 0 0-1-4.466c-.263-.473-.501-.958-.715-1.455a4.463 4.463 0 0 1-.288-1.665c-.738.394-1.172 1.2-1.87 1.667-.445.27-.94.451-1.454.532a10.977 10.977 0 0 1-4.998-.174c-.644-.174-1.465-.356-1.87.174-.252.328-.209.783-.243 1.196-.056.45-.165.892-.324 1.316l-1.004 3.032c-.34-.29-.828-.633-.892-1.078z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.213 44.064c-3.185 2.04-5.404-1.42-5.506-1.592a5.013 5.013 0 0 0 4.895 0 1.498 1.498 0 0 0 .569 1.516l.042.076z",
    fill: "url(#775dgbv1lf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.191 35.804c-.132-.173-.272-.38-.208-.591.064-.212.288-.322.29-.527a.411.411 0 0 0-.161-.297.66.66 0 0 0-.396-.173.26.26 0 0 0-.146.032.3.3 0 0 0-.108.146c-.222.497-.148 1.08.047 1.588a.805.805 0 0 0 .15.263.757.757 0 0 0 .33.176c.19.061.413.063.456-.174.032-.17-.166-.322-.254-.443z",
    fill: "url(#9z5qcu7c7g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.683 35.842c.132-.173.273-.38.208-.591-.064-.213-.288-.322-.291-.527a.415.415 0 0 1 .162-.298.65.65 0 0 1 .396-.172c.05-.004.1.007.144.032.051.036.09.087.11.146.22.496.146 1.08-.049 1.588a.603.603 0 0 1-.478.44c-.189.06-.413.062-.458-.175-.03-.167.161-.322.256-.443z",
    fill: "url(#fmnzhi7rph)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.182 39.44a.892.892 0 0 0 .597-.145.628.628 0 0 0 .233-.19c.155-.243-.015-.583.096-.848a.718.718 0 0 1 .533-.356.38.38 0 0 1 .239 0 .396.396 0 0 1 .174.356c.038.6-.154 1.193-.538 1.656a2.199 2.199 0 0 1-1.55.777.16.16 0 0 1-.089-.014.146.146 0 0 1-.06-.087 1.038 1.038 0 0 1 .189-1.017",
    fill: "url(#8s4ap62d4i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.332 38.657c.087.146.263.203.41.288a1.01 1.01 0 0 1 .488.843.527.527 0 0 1-.322.538c-.21.059-.42-.09-.568-.252a2.176 2.176 0 0 1-.554-1.57c.012-.19.093-.667.396-.569.243.085.033.525.15.722z",
    fill: "url(#8pcgb7rb3j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.017 32.865a1.856 1.856 0 0 0-.347.959c-.038.5-.02 1.001.053 1.497l.286 2.574c.356-1.231 1.197-2.305 1.389-3.573.06-.403.049-.824.178-1.214.057-.17.394-.591.269-.758-.125-.167-.843-.034-1.03.019-.312.079-.59.252-.798.496z",
    fill: "url(#jzr0l95iok)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.162 28.567a.153.153 0 0 1 .095-.02c.041.01.066.05.089.088.435.744.879 1.504 1.07 2.347.1.466.14.943.12 1.42a8.594 8.594 0 0 1-1.43 4.491c-.179-.59-.16-1.222-.302-1.822-.19-.815-.665-1.53-1.08-2.257-.379-.663-1.04-1.783-.559-2.506a4.547 4.547 0 0 1 1.997-1.741z",
    fill: "url(#egbyr1b3pl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.042 41.603s1.078 1.315 3.423 1.385c2.531.076 3.725-.86 3.725-.86s-1.116 2.463-3.903 3.012c-1.764.352-3.747-.405-4.102-1.326 0 .01 1.156-1.065.857-2.211z",
    fill: "url(#rwfmuh22pm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.873 46.862s.684 3.266 3.115 4.026c2.43.76 4.483-1.67 4.558-3.266.076-1.595.457-1.137.457-1.137l.608.38v6.001l-4.634-.686-4.558 1.292s-1.216-5.471-.533-6.99",
    fill: "#FCC665"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "6in5nwq4hb",
    x1: 30.271,
    y1: 36.351,
    x2: 36.673,
    y2: 30.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9iuf7nq83c",
    x1: 18.123,
    y1: 39.201,
    x2: 18.674,
    y2: 32.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o0l7y7xvpd",
    x1: 26.041,
    y1: 34.686,
    x2: 25.814,
    y2: 44.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n6u4rk6xke",
    x1: 42.228,
    y1: 50.034,
    x2: 49.982,
    y2: 39.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "775dgbv1lf",
    x1: 25.842,
    y1: 46.14,
    x2: 27.362,
    y2: 39.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9z5qcu7c7g",
    x1: 57.977,
    y1: 35.288,
    x2: 61.397,
    y2: 35.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fmnzhi7rph",
    x1: 73.895,
    y1: 35.326,
    x2: 70.476,
    y2: 35.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8s4ap62d4i",
    x1: 54.444,
    y1: 39.983,
    x2: 49.151,
    y2: 37.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8pcgb7rb3j",
    x1: 36.705,
    y1: 39.521,
    x2: 39.725,
    y2: 38.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jzr0l95iok",
    x1: 39.489,
    y1: 37.533,
    x2: 38.121,
    y2: 31.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "egbyr1b3pl",
    x1: 54.934,
    y1: 29.304,
    x2: 49.502,
    y2: 35.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rwfmuh22pm",
    x1: 66.242,
    y1: 47.737,
    x2: 62.752,
    y2: 31.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("filter", {
    id: "811a1icpxa",
    x: -10,
    y: -7,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12242_199709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_12242_199709"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_12242_199709",
    result: "effect2_dropShadow_12242_199709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12242_199709",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentOrganizations);
export default __webpack_public_path__ + "static/media/student-organizations.00894f5cf08cf6ccde9510cbfb5371cb.svg";
export { ForwardRef as ReactComponent };